import { useRouter } from '@atlassian/react-resource-router';

// Based on src/packages/spa-apps/common/src/redirect/login/index.tsx
// Assume that if the path ends with /embed we are in an embedded page (this is the convention for issue create and issue view)

export const useIsEmbed = () => {
	const [
		{
			location: { pathname },
		},
	] = useRouter();

	if (pathname.endsWith('/embed')) {
		return { isEmbed: true };
	}
	return { isEmbed: false };
};
